/* eslint-disable guard-for-in */
import {
	DEFAULT_PER_PAGE_LIMIT,
	DEFAULT_SORT,
	SORT,
	PAGE_SIZES,
	LIMIT_PAGE_SIZE
} from "./constants";
import SearchParams from "./SearchParams";

let klevu_query = {};
let klevu_filters = {};

export function getLimitNumberOfProduct() {
	return window.PRODUCT_LISTING_BLOCK_CONFIG ?
		window.PRODUCT_LISTING_BLOCK_CONFIG.LimitNumberOfProduct :
		0;
}

export function getPageSizes() {
	if (enablePropArray('PageSizes')) {
		return window.PRODUCT_LISTING_BLOCK_CONFIG.PageSizes
			.reduce(function (previousValue, currentValue) {
				if (currentValue.Value <= LIMIT_PAGE_SIZE) {
					return [...previousValue, optionItem(currentValue.Value, currentValue.Text)];
				}
				return previousValue;
			}, []);
	}

	return PAGE_SIZES.map(page => optionItem(page, page));
}
export function getPageSortes() {
	if (enablePropArray('Sorting')) {
		return window.PRODUCT_LISTING_BLOCK_CONFIG.Sorting
			.reduce(function (previousValue, currentValue) {
				if (!currentValue.Disabled) {
					previousValue.push(optionItem(SORT[currentValue.Value], currentValue.Text));
				}
				return previousValue;
			}, [optionItem("RELEVANCE", "Relevance")]);
	}

	return [];
}

export function isPatternByPLU() {
	const searchParams = new SearchParams();
	const q = decodeURIComponent(searchParams.get('q'));
	const filters = q.split(/[\s+]/gi);
	const isPattern = new RegExp(/^[\d\s+]+$/gi).test(q);

	return isPattern && filters.length > 1;
}

export function generateFilterPLU(filters) {
	const searchParams = new SearchParams();
	const q = searchParams.get('q');
	const klevuFilters = {
		plu: {
			key: 'plu',
			values: q.split(/\s+/)
		},
	};

	return Object.values(klevu.extend(filters.reduce(function(acc, cur) {
		if (cur.key !== 'plu') {
			acc.push(cur);
		}
		return acc;
	}, []), klevuFilters));
}

export function generateFilters(filters) {
	let objectFilters = filters.reduce(
		(previous, current) => klevu.extend(previous, {
			[current.key]: current
		}), {}
	);
	// Additional products / bundles
	if(enablePropArray('ProductCodeList')) {
		klevu_filters = {
			productCode: {
				key: "productCode",
				values: window.PRODUCT_LISTING_BLOCK_CONFIG.ProductCodeList
			}
		};
	// PLB product / bundles
	} else if (window.PRODUCT_LISTING_BLOCK_CONFIG) {
		const {
			PresetFilter,
			MappingFieldList,
			ShowNewInOnly,
			ShowOnlyClearance,
			ShowOnlyProductDiscount,
			ShowOnlyDropship,
			Ancestors,
			ExcludeBundles,
			ShowBothClearanceAndHotPrice,
		} = window.PRODUCT_LISTING_BLOCK_CONFIG;

		if (Ancestors) {
			klevu_filters.ancestors = {
				key: "ancestors",
				settings: {
					singleSelect: false
				},
				values: Ancestors
			}
		}

		if (ShowNewInOnly) {
			klevu_filters.isNewIn = {
				key: "isNewIn",
				settings: {
					singleSelect: true
				},
				values: ["True"]
			};
		}

		if (ShowOnlyClearance) {
			klevu_filters.isClearancePrice = {
				key: "isClearancePrice",
				settings: {
					singleSelect: true
				},
				values: ["True"]
			};
		}

		if (ShowOnlyProductDiscount) {
			klevu_filters.isHotPrice = {
				key: "isHotPrice",
				settings: {
					singleSelect: true
				},
				values: ["True"]
			};
		}

		if (ShowOnlyDropship) {
			klevu_filters.isIncludeDropship = {
				key: "isIncludeDropship",
				settings: {
					singleSelect: true
				},
				values: ["True"]
			};
		}

		if (ExcludeBundles) {
			klevu_filters.isBundle = {
				key: "isBundle",
				settings: {
					singleSelect: true
				},
				values: ["False"]
			};
		}

		if (PresetFilter && MappingFieldList) {
			objectFilters = klevu.extend(objectFilters, generateFilter(PresetFilter, MappingFieldList));
		}
	}

	return Object.values(klevu.extend(objectFilters, klevu_filters || {}));
}

export function generateGroupCondition(settings) {
	let setting = {};
	if (window.PRODUCT_LISTING_BLOCK_CONFIG) {
		const {
			ShowBothClearanceAndHotPrice,
		} = window.PRODUCT_LISTING_BLOCK_CONFIG;

		if (ShowBothClearanceAndHotPrice) {
			setting = {
				groupCondition: {
					groupOperator: 'ANY_OF',
					conditions: [{
							key: 'isClearancePrice',
							settings: {
								singleSelect: true,
							},
							valueOperator: 'INCLUDE',
							values: ['True'],
						},
						{
							valueOperator: 'INCLUDE',
							key: 'isHotPrice',
							settings: {
								singleSelect: true,
							},
							values: ['True'],
						},
					],
				},
			};
		}
	}

	return klevu.extend(settings, setting);
}

export function keyExistQueries() {
	const presetFilterSetting = presetFilterServices().getSetting();
	// Hide facet when this is a category(type).
	if (presetFilterSetting['type'] && presetFilterSetting['type'].length == 1) {
		klevu_filters.type = true;
	}

	return Object.keys(klevu_filters);
}

export function presetFilterServices () {
	window.settingPresetFilter = window.settingPresetFilter || Object.entries(getPresetFilter()).reduce((acc, cur) => {
		const key = 0;
		const value = 1;
		acc[cur[key]] = cur[value].values;
		return acc;
	}, {});

	return {
		delete(key) {
			if (window.settingPresetFilter[key]) {
				delete window.settingPresetFilter[key];
			}
		},
		getSetting() {
			return window.settingPresetFilter;
		},
		get(key) {
			return window.settingPresetFilter[key] || [];
		},
		exists(key) {
			return !!window.settingPresetFilter[key];
		}
	}
}

export function excludePresetFilter(filter) {
	filter.forEach((filter) => {
		filter.key !== 'type' && presetFilterServices().delete(filter.key);
	});
}

export function getPresetFilter() {
	let presetFilter = {};
	if (window.PRODUCT_LISTING_BLOCK_CONFIG) {
		const {
			PresetFilter,
			MappingFieldList,
		} = window.PRODUCT_LISTING_BLOCK_CONFIG;

		if (PresetFilter && MappingFieldList) {
			presetFilter = generateFilter(PresetFilter || '', MappingFieldList);
		}
	}

	return presetFilter;
}

export function isPagePLB() {
	return !!window.APPLY_KLEVU_LAYOUT;
}

export function getPageSize() {
	const searchParams = new SearchParams();
	const pageSize = searchParams.get('page_size');
	if(pageSize) {
		return pageSize;
	} else if (enablePropArray('PageSizes')) {
		const sizeSelected = window.PRODUCT_LISTING_BLOCK_CONFIG.PageSizes.find(({ Selected }) => Selected);
		if (klevu.isEmptyObject(sizeSelected)) {
			return getLimitPageSize(window.PRODUCT_LISTING_BLOCK_CONFIG.PageSizes[0].Value);
		} else {
			return getLimitPageSize(sizeSelected.Value);
		}
	}

	return DEFAULT_PER_PAGE_LIMIT;
}

export function getSortCriterias() {
	const searchParams = new SearchParams();
	const sort = searchParams.get('sort');
	if(sort) {
		return sort;
	} else if (enablePropArray('Sorting')) {
		const { Sorting } = window.PRODUCT_LISTING_BLOCK_CONFIG;
		const sortSeleted = Sorting.find(({ Selected }) => Selected);
		if (!klevu.isEmptyObject(sortSeleted)) {
			return SORT[sortSeleted.Value];
		}
	}

	return DEFAULT_SORT;
}

export function getLimitPageSize(pageSize) {
	return pageSize > LIMIT_PAGE_SIZE ? LIMIT_PAGE_SIZE : pageSize;
}

export function getTotalResults(total) {
	const limit = getLimitNumberOfProduct();
	return (total > limit && limit > 0) ? limit : total;
}

function optionItem(value, text) {
	return { value, text }
}

function enablePropArray(item) {
	return isPagePLB() &&
		window.PRODUCT_LISTING_BLOCK_CONFIG &&
		klevu.isArray(window.PRODUCT_LISTING_BLOCK_CONFIG[item]) &&
		window.PRODUCT_LISTING_BLOCK_CONFIG[item].length;
}

function generateFilter(query, mappingFieldList) {
    return query
        .split('&')
        .reduce((acc, curr) => {
            const [name, value] = curr.split('=');

            if (name && value) {
                const keys = (mappingFieldList[name] || name).split(',');
                const values = decodeURIComponent(convertPlusToSpace(value)).split('|');
                keys.forEach((key) => {
                    acc[key] ={
                        key,
                        settings: {
                            singleSelect: false,
                        },
                        values,
                    };
                });
            }

            return acc;
        }, {});
}

export function addPromoImage(records) {
	if (enablePromoImage()) {
		const indexPromoImage = 3;
		const promoImage = klevu.extend({ IsPromoTile: true }, window.PROMO_IMAGE);
		records.splice(indexPromoImage, 0, promoImage);
	}
}

export function enablePromoImage() {
	return window.PROMO_IMAGE;
}

export function convertPlusToSpace(value) {
	return value.replace(/\+/gi, ' ').replace(/%2B/gi, '%20');
}

export function toLowerCaseFirst(text) {
	return text ? text[0].toLowerCase() + text.slice(1) : '';
}

export function decimalFormat(text) {
	return isNaN(text) ? text : Number(text);
}

export function booleanFormat(filterKey, filterOptionName, fallback) {
	const startsWith = 'akeneo';
	const isStartsWith = filterKey.toLowerCase().startsWith(startsWith);
	const isSpecial = (window.KlevuFacetYesNo || '').split(',').includes(filterKey);

	if (isStartsWith || isSpecial) {
		const mapingText = {
			true: 'Yes',
			false: 'No'
		};

		return mapingText[filterOptionName.toLocaleLowerCase()] || fallback;
	}

	return fallback;
}

export function enableVisitorGroupDiscount() {
	return !!window.isInVisitorGroup;
}

export function showColor(
	color,
	callBackItem,
	callBackMore = null,
	keyChain = 'ColourCode|ColourName|Sku|HexColour|ImageUrl|VariantImageUrl|IsOutOfStock'
	) {
	if (color) {
		const colors = color.split('--');
		const LIMIT = 4;
		for (const i in colors) {
			if (i >= LIMIT) break;
			const color			= colors[i];
			const values	 	= color.split('|');
			const keys 			= keyChain.split('|');
			const colorObject 	= {};
			for (const i in values) {
				colorObject[keys[i]] = values[i]
					.replace(/https \/\//gi, 'https://')
					.replace(/https:\/\/localhost /gi, 'https://localhost:');

				if (keys[i] === 'HexColour' && values[i]) {
					const hexColours = values[i].split(',');
					if (hexColours.length === 1) {
						colorObject.colourSwatch = `background-color:${hexColours[0]}`;
					} else if (hexColours.length === 2) {
						colorObject.colourSwatch = `background: linear-gradient(135deg, ${hexColours[0]} 50%, ${hexColours[1]} 50%); border: 1px solid #000`;
					} else if (hexColours.length === 3) {
						colorObject.colourSwatch = `background: conic-gradient(${hexColours[1]} 120deg, ${hexColours[2]} 120deg 240deg, ${hexColours[0]} 240deg 360deg)`;
					}
				}
			}
			callBackItem(colorObject, i);
		}
		if (colors.length > LIMIT && callBackMore) {
			callBackMore(colors.length - LIMIT);
		}
	}
}

export function generateCustomANDQuery(settings) {
	let customANDQuery = '';
	if (window.PRODUCT_LISTING_BLOCK_CONFIG) {
		const {
			ShowNewInOnly,
			ShowOnlyClearance,
			ShowOnlyProductDiscount,
			ShowOnlyDropship,
			ExcludeBundles,
			ShowBothClearanceAndHotPrice,
			Ancestors,
			ProductCodeList,
			ShowBothCategoryAndProductDiscounts,
			ShowClearanceCategoryandProductDiscounts,
		} = window.PRODUCT_LISTING_BLOCK_CONFIG;

		let settingOnly = {};
		let settingAncestors = {};
		let settingBoth = {};
		let settingSpecified = {};
		let settingPresetFilter = {}

		if (enablePropArray('ProductCodeList')) {
			settingSpecified.productCode = ProductCodeList;
		} else {
			settingPresetFilter = presetFilterServices().getSetting();

			if (ShowNewInOnly) {
				settingOnly.isNewIn = 'True';
			}
			if (ShowOnlyClearance) {
				settingOnly.isClearancePrice = 'True';
			}
			if (ShowOnlyProductDiscount) {
				settingOnly.isHotPrice = 'True';
			}
			if (ShowOnlyDropship) {
				settingOnly.isIncludeDropship = 'True';
			}
			if (ExcludeBundles) {
				settingOnly.isBundle = 'False';
			}
			if (enablePropArray('Ancestors')) {
				settingAncestors.ancestors = Ancestors;
			}
			if (ShowBothClearanceAndHotPrice) {
				settingBoth.isClearancePrice = 'True';
				settingBoth.isHotPrice = 'True';
			}
			if (ShowBothCategoryAndProductDiscounts) {
				settingBoth.isDiscountPrice = "True";
				settingBoth.isHotPrice = "True";
			}
			if (ShowClearanceCategoryandProductDiscounts) {
				settingBoth.isClearancePrice = 'True';
				settingBoth.isDiscountPrice = "True";
				settingBoth.isHotPrice = 'True';
			}
		}

		const queryOnlyFilters = getGroupQuery(settingOnly, 'AND');
		const queryBothFilters = getGroupQuery(settingBoth, 'OR');
		const queryAncestores = getGroupQuery(settingAncestors, 'AND');
		const querySpecified = getGroupQuery(settingSpecified, 'OR');
		const queryPresetFilter = getGroupQuery(settingPresetFilter, 'AND');

		const queryMain = joinQuery(queryAncestores).andGroup(
			joinQuery(queryOnlyFilters).or(queryBothFilters).toString()
		).and(queryPresetFilter).toString();

		customANDQuery = joinQuery().orGroup(queryMain).orGroup(querySpecified).toString();
		klevu.extend(window.PRODUCT_LISTING_BLOCK_CONFIG, {customANDQuery});
	}

	return klevu.extend(settings, {customANDQuery});
}

function joinQuery(query = '') {
	const listQuery = query ? [query] : [];
	return {
		and(custom) {
			if (custom) {
				listQuery.push(custom);
				query = listQuery.join(' AND ');
			}
			return joinQuery(query);
		},
		andGroup(custom) {
			if (custom) {
				listQuery.push(`(${custom})`);
				query = listQuery.join(' AND ');
			}
			return joinQuery(query);
		},
		or(custom) {
			if (custom) {
				listQuery.push(custom);
				query = listQuery.join(' OR ');
			}
			return joinQuery(query);
		},
		orGroup(custom) {
			if (custom) {
				listQuery.push(`(${custom})`);
				query = listQuery.join(' OR ');
			}
			return joinQuery(query);
		},
		toString() {
			return query;
		},
	};
}

function getGroupQuery(queryParams, condition) {
	const queries = [];
	for (const [key, value] of Object.entries(queryParams)) {
		if (value && window.klevu.isArray(value)) {
			queries.push(`${key}:(${value.map((val) => `\"${val}\"`).join(',')})`);
		} else if (value) {
			queries.push(`${key}:(\"${value}\")`);
		}
	}
	return queries.length ? `(${queries.join(` ${condition} `)})` : '';
}
export function updateCssClassFilters(filterOnClick = '') {
	const $kuFilterBoxes = document.querySelectorAll('.kuFilterBox');
	klevu.setObjectPath(window, 'klevuElementClass', {});
	$kuFilterBoxes.forEach(($kuFilterBox) => {
		const filter = $kuFilterBox.dataset.filter || '' ;
		const $filterSelected = $kuFilterBox.querySelectorAll('.kuSelected');

		if ($filterSelected.length || filter === filterOnClick ) {
			const $kuFilterHead = $kuFilterBox.querySelector('.kuFilterHead');
			const $kuFilterNames = $kuFilterBox.querySelector('.kuFilterNames');

			klevu.setObjectPath(window, `klevuElementClass.kuFilterHead[${filter}]`, $kuFilterHead.className);
			klevu.setObjectPath(window, `klevuElementClass.kuFilterNames[${filter}]`, $kuFilterNames.className);
		}
	});
}




// WEBPACK FOOTER //
// ./klevu/utils.js